<app-sanctuary-sidebar />
<app-page-tour [steps]="dashboardSteps()" storageKey="uplift-dashboard-tour-seen" routePrefix="/home" [ariaLabel]="'tour.ariaLabel.dashboard' | transloco" />
<app-page-tour [steps]="courseSessionsSteps" storageKey="uplift-course-sessions-tour-seen-v2" routePrefix="/course-sessions" [ariaLabel]="'tour.ariaLabel.courseSessions' | transloco" />
<app-page-tour [steps]="myJourneySteps" storageKey="uplift-my-journey-tour-seen" routePrefix="/my-journey" [ariaLabel]="'tour.ariaLabel.myJourney' | transloco" />

<div class="wrapper tw-flex tw-flex-1 tw-flex-col">
  <div class="main-panel tw-flex tw-flex-1 tw-flex-col">
    <main id="main-content" tabindex="-1" class="main-content tw-flex tw-flex-1 tw-flex-col">
      <div class="content-overlay"></div>
      <div
        class="content-wrapper me-auto tw-flex tw-w-full tw-flex-1 tw-flex-col"
      >
        <router-outlet></router-outlet>
      </div>
    </main>
    <app-footer></app-footer>


  </div>
</div>
